

























import { Component } from "vue-property-decorator";
import { required } from "@/shared/validators";
import Modal from "@/shared/components/modal.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { AcaoLead, AcoesLeadService } from "@/services/acoes-lead.service";
import ComboMotivoLead from "../components/ComboMotivoLead.vue";
import DatePickerCalendar from "@/shared/components/date-picker-calendar.vue";

@Component({
  components: { Modal, ComboMotivoLead, DatePickerCalendar },
})
export default class ReagendarAtendimento extends mixins(GlobalMixin) {
  loading = false;
  observacao: string | null = null;
  acaoLead: AcaoLead = {} as AcaoLead;

  rules = {
    observacao: [required()],
  };

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async adicionarAcaoLead(idLead: number) {
    this.acaoLead.idLead = idLead;
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    return p;
  }

  async salvarAcaoLead() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      try {
        if (this.acaoLead) {
          await AcoesLeadService.manterAcaoLead(this.acaoLead);
        }
        return modal.close(true);
      } finally {
        this.loading = false;
      }
    }
  }
}
